export const boxName = state => state.active.name;

export const boxKind = state => state.active.kind;

export const boxFormat = state => state.active.format;

export const boxThemeSlug = state => state.active.theme_slug;

export const boxThemeFonts = state => state.active.theme_fonts;

export const boxList = state => state.list;

export const boxId = state => state.active.id;

export const boxActive = state => state.active;

export const boxConfig = state => state.active.config;

export const showKlickpagesHeader = state => state.showKlickpagesHeader;



/** WEBPACK FOOTER **
 ** ./src/store/modules/box/getters.js
 **/